export default __webpack_public_path__ + "static/media/sa-1-2-3.6dc0ed6b.png";